module.exports = __webpack_public_path__ + "images/instructor-rahul-singh-47-mobile.webp";